 ko.bindingHandlers["blockTab"] =
     "init": (element, valueAccessor) ->
         blockTab = ko.unwrap(valueAccessor())
         blockTab = if blockTab? then blockTab else true
         $(element).keydown (e) ->
             keyCode = if e.which then e.which else e.keyCode
             if keyCode == 9
                 e.preventDefault() if blockTab